import { Loading } from './scripts/loading';

const loading = new Loading();

const getMobileOperatingSystem = (): 'iOS' | 'Android' | 'unknown' => {
	const userAgent = navigator.userAgent || navigator.vendor;

	if (/android/i.test(userAgent)) {
		return 'Android';
	}

	// iOS detection from: http://stackoverflow.com/a/9039885/177710
	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
		return 'iOS';
	}

	return 'unknown';
};

if (getMobileOperatingSystem() === 'iOS') {
	loading.iosLoad();
} else {
	loading.loadAudio();
}
